/**
 * @generated SignedSource<<13d502826727b014531d41b8ab961b01>>
 * @relayHash a996f39da569aaa6a0aecd98958abdca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4d46638962661fd5c059ac738cba6cc19abc8df458037d395335f756db7fea5b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4d46638962661fd5c059ac738cba6cc19abc8df458037d395335f756db7fea5b",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
